module.exports = __webpack_public_path__ + "static/media/ZW.27cfa398.png";